import { render, staticRenderFns } from "./VsTr.vue?vue&type=template&id=582b2cfb"
import script from "./VsTr.vue?vue&type=script&lang=js"
export * from "./VsTr.vue?vue&type=script&lang=js"
import style0 from "./VsTr.vue?vue&type=style&index=0&id=582b2cfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports